<div class="component-viewer">
    <mat-card>
        <mat-card-header style="display: inline;">
            <div class="row w-100">
                <div class="col-6 text-start">
                    <h2 class="mb-0">Addons</h2>
                </div>
                <div class="col-6 text-end">
                    <button mat-raised-button (click)="create()">Add <mat-icon>add</mat-icon></button>
                </div>
            </div>
        </mat-card-header>
        <mat-card-content>
            <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="15" [updateFilterEvent]="updateFilterEvent"
            [filter]="filter" [data]="addons" (filterChanged)="getAddons()" (filterReset)="resetFilter()">
        </gt-table>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        <table mat-table [dataSource]="addons" matSort (matSortChange)="sortData($event)">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="name"> Name </th>
                <td mat-cell *matCellDef="let addon"> {{addon.name}} </td>
            </ng-container>
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="description"> Description </th>
                <td mat-cell *matCellDef="let addon"> {{addon.description}} </td>
            </ng-container>
            <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="price"> Price </th>
                <td mat-cell *matCellDef="let addon"> {{addon.price | currency}} </td>
            </ng-container>
            <ng-container matColumnDef="isActive">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="isActive"> Active </th>
                <td mat-cell *matCellDef="let addon">
                    <section>
                        <mat-slide-toggle
                            [checked]="addon.isActive"
                            (change)="updateIsAvailable(addon, $event.checked)">
                            <ng-container *ngIf="addon.isActive">Yes</ng-container>
                            <ng-container *ngIf="!addon.isActive">No</ng-container>
                        </mat-slide-toggle>
                    </section>
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let addon">
                    <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #actionsMenu>
                        <button mat-menu-item (click)="edit(addon)">
                            Edit <mat-icon>edit</mat-icon>
                        </button>&nbsp;
                        <button mat-menu-item (click)="delete(addon)">
                            Delete <mat-icon>delete</mat-icon>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        </mat-card-content>
    </mat-card>
</div>